// extracted by mini-css-extract-plugin
module.exports = {"heading":"_2AqEny-bV4","template-info":"_1OyZOxy9gr","templateInfo":"_1OyZOxy9gr","name":"_3K8QYbheg2","info":"_3iBL9-1d8c","description":"UjPzhIq-LG","divider":"_3XrSfBMV82","h-rule":"DphIPwPwSL","hRule":"DphIPwPwSL","logo":"_3LvOT5PUeJ"};
    if(module.hot) {
      // 1614934752343
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  